import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { accentClasses } from './accent';

@Component({
  selector: 'app-card-header',
  standalone: true,
  imports: [RouterLink],
  template: `
    <div class="flex items-start justify-between gap-3">
      <div class="flex min-w-0 items-center gap-3">
        @if (icon()) {
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg" [class]="chip()">
          <i [class]="icon()" class="text-base"></i>
        </span>
        }
        <div class="flex min-w-0 flex-col">
          <h3 class="truncate text-sm font-semibold text-text-main">{{ title() }}</h3>
          @if (subtitle()) {
          <span class="truncate text-xs text-text-muted">{{ subtitle() }}</span>
          }
        </div>
      </div>

      <div class="flex shrink-0 items-center gap-2">
        <ng-content select="[header-actions]" />
        @if (link()) {
        <a
          [routerLink]="link()"
          class="whitespace-nowrap text-xs font-medium text-primary-600 hover:underline dark:text-primary-400"
        >
          {{ linkLabel() || 'View all' }} <i class="pi pi-arrow-right text-[0.6rem]"></i>
        </a>
        }
      </div>
    </div>
  `,
})
export class CardHeaderComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  icon = input<string>('');
  accent = input<string>('');
  link = input<string | any[] | undefined>(undefined);
  linkLabel = input<string>('');

  chip(): string {
    return accentClasses(this.accent());
  }
}
